export const createSelector = (...selectors) => (state) =>
    [state, ...selectors].reduce((a, b) => b(a));
